import { Component, OnInit } from '@angular/core';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
import { SiteService } from 'src/app/services/site.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppFormat } from '../../../appFormat';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/appSettings';
import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';

import { faImage } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-personalizacao',
  templateUrl: './personalizacao.component.html',
  styleUrls: ['./personalizacao.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class PersonalizacaoComponent implements OnInit {
  public loading: boolean = false;

  public faImage = faImage;

  public count_upload: number = 0;

  public changed: boolean;
  public websiteFrm: FormGroup;

  // aparencia & cor
  public color_background = '#FFFFFF';
  public color_background_header = '#FFFFFF';
  public color_primary = '#FFFFFF';
  public color_secondary = '#FFFFFF';
  public color_btn_buy = '#FFFFFF';
  public color_btn_cart = '#FFFFFF';
  public color_offer_tag = '#FFFFFF';

  public offer_tag_format!: FormControl;
  public font_primary!: FormControl;
  public font_secondary!: FormControl;
  public font_btn!: FormControl;
  public font_link!: FormControl;

  public imageLogo: string = '';

  public uploader!: FileUploader;
  public hasBaseDropZoneOver: boolean = false;

  public imageFavicon: string = '';

  public uploaderFavicon!: FileUploader;
  public hasBaseDropZoneOverFavicon: boolean = false;

  public offer_tag_format_list: any[] = [
    'diagonal',
    'quadrado',
    'estrela',
    'circulo',
  ];

  public font_list: any[] = [
    "'Nunito', sans-serif",
    'Trebuchet MS, sans-serif',
    'Verdana, sans-serif',
    'Tahoma, sans-serif',
    'Georgia, sans-serif',
  ];

  constructor(
    private _apiService: ApiService,
    private _siteService: SiteService
  ) {
    /**
     *
     * envio do logo do estabelecimento
     *
     */

    this.uploader = new FileUploader({
      url: this._apiService.API_PATH,
      allowedFileType: ['image'],
      allowedMimeType: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      maxFileSize: 1048576 * 2,
      filters: [
        {
          name: 'imageFilter',
          fn: function (item: FileLikeObject | undefined, options) {
            if (item === undefined) return false;
            var type =
              '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
          },
        },
      ],
    });

    this.uploader.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }

      this.imageLogo = '';
      this.onChangeDetail();
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.imageLogo = responsePath['imagem_cabecalho'];
        }
      }
    };

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();

      this.count_upload -= 1;

      if (this.count_upload <= 0) {
        this.saveComplete();
      }
    };

    this.uploader.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploader.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!',
        'error'
      );
    };

    /**
     *
     * envio do logo do estabelecimento
     *
     */

    this.uploaderFavicon = new FileUploader({
      url: this._apiService.API_PATH,
      allowedFileType: ['image'],
      allowedMimeType: ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/x-icon', 'image/vnd.microsoft.icon'],
      maxFileSize: 1048576 * 2,
      filters: [
        {
          name: 'imageFilter',
          fn: function (item: FileLikeObject | undefined, options) {
            if (item === undefined) return false;
            var type =
              '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
              console.log()
            return '|jpg|png|jpeg|gif|webp|ico|icon|vnd.microsoft.icon|'.indexOf(type) !== -1;
          },
        },
      ],
    });

    this.uploaderFavicon.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.uploaderFavicon.queue.length > 1) {
        this.uploaderFavicon.removeFromQueue(this.uploaderFavicon.queue[0]);
      }

      this.imageFavicon = '';
      this.onChangeDetail();
    };

    this.uploaderFavicon.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.imageFavicon = responsePath['favicon'];
        }
      }
    };

    this.uploaderFavicon.onCompleteAll = () => {
      this.uploaderFavicon.clearQueue();
      this.count_upload -= 1;

      if (this.count_upload <= 0) {
        this.saveComplete();
      }
    };

    this.uploaderFavicon.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploaderFavicon.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      console.log(item, filter, options)
      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de imagem (ico, png, jpg, webp, gif) com no máximo 2 MB de tamanho!',
        'error'
      );
    };
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();

    this.getPaymentMethodsConfig();
  }

  getPaymentMethodsConfig() {
    this.loading = true;
    this._siteService.getParameters().subscribe((res) => {
      this.resParameters(res);
      this.loading = false;
    });
  }

  resParameters(res) {
    if (res['success']) {
      this.color_background = '#' + res.color_background;
      this.color_background_header = '#' + res.color_background_header;
      this.color_primary = '#' + res.color_primary;
      this.color_secondary = '#' + res.color_secondary;
      this.color_btn_buy = '#' + res.color_btn_buy;
      this.color_btn_cart = '#' + res.color_btn_cart;
      this.color_offer_tag = '#' + res.color_offer_tag;

      this.offer_tag_format.setValue(res.offer_tag_format);
      this.font_primary.setValue(res.font_primary);
      this.font_secondary.setValue(res.font_secondary);
      this.font_btn.setValue(res.font_btn);
      this.font_link.setValue(res.font_link);

      if (res.logo && res.logo != '') {
        this.imageLogo = res.logo;
      }

      if (res.favicon && res.favicon != '') {
        this.imageFavicon = res.favicon;
      }
    }
  }

  createFormControls() {
    // aparencia & cor
    this.offer_tag_format = new FormControl(null);

    this.font_primary = new FormControl('');
    this.font_secondary = new FormControl('');
    this.font_btn = new FormControl('');
    this.font_link = new FormControl('');
  }

  private createForm() {
    this.websiteFrm = new FormGroup({
      offer_tag_format: this.offer_tag_format,
      font_primary: this.font_primary,
      font_secondary: this.font_secondary,
      font_btn: this.font_btn,
      font_link: this.font_link,
    });
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverBaseFavicon(e: any): void {
    this.hasBaseDropZoneOverFavicon = e;
  }

  onChangeDetail() {
    this.changed = true;
  }

  onCancel() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
    }).then((result) => {
      if (result.value) {
        this.loading = true;
        this.changed = false;
        this.uploader.clearQueue();
        this.uploaderFavicon.clearQueue();
        this.getPaymentMethodsConfig();
      }
    });
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar salvar.', 'error');
  }

  saveComplete() {
    this.changed = false;
    Swal.fire(
      'Salvo!',
      'As personalizações da loja online foram salvas',
      'success'
    );
  }

  saving() {
    Swal.fire({
      title: 'Salvando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  onSubmit() {
    this.saving();

    let data = {
      color_background: this.color_background,
      color_background_header: this.color_background_header,
      color_primary: this.color_primary,
      color_secondary: this.color_secondary,
      color_btn_buy: this.color_btn_buy,
      color_btn_cart: this.color_btn_cart,
      color_offer_tag: this.color_offer_tag,
      offer_tag_format: this.offer_tag_format.value,
      font_primary: this.font_primary.value,
      font_secondary: this.font_secondary.value,
      font_btn: this.font_btn.value,
      font_link: this.font_link.value,
    };

    this._siteService.storeParameters(data).subscribe((res) => {
      //save image if
      if (this.uploader.queue.length > 0 || this.uploaderFavicon.queue.length > 0) {

        if (this.uploader.queue.length > 0) {
          this.count_upload += 1;
          this.uploader.setOptions(this._siteService.getUrlLogoOptions());
          this.uploader.uploadAll();
        }

        if (this.uploaderFavicon.queue.length > 0) {
          this.count_upload += 1;
          this.uploaderFavicon.setOptions(this._siteService.getUrlFaviconOptions());
          this.uploaderFavicon.uploadAll();
        }

      } else {
        this.saveComplete();
      }
    });
  }
}
